import { render, staticRenderFns } from "./pages11.vue?vue&type=template&id=036f394e&scoped=true&"
import script from "./pages11.vue?vue&type=script&lang=js&"
export * from "./pages11.vue?vue&type=script&lang=js&"
import style0 from "./pages11.vue?vue&type=style&index=0&id=036f394e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f394e",
  null
  
)

export default component.exports